import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  MAIN_COLOR,
  GRAY_DARKER,
  FONT_SIZE_7,
  GRAY_MEDIUM,
  FONT_WEIGHT_BOLD,
  GRAY_LIGHTER,
} from '../../styles/variables';

export const RadioContainer = styled.div`
  ${flexPosition({ align: 'flex-start', justify: 'flex-start' })};
  margin-top: ${props => (props.customDescStyles ? '28px' : '0px')};
  label {
    margin-bottom: ${props => (props.customDescStyles ? '0px' : '')};
  }
`;

export const InputContainer = styled.span`
  display: flex;
  margin-right: 10px;
  margin-top: ${props => (props.customDescStyles ? '0px' : '2px')};
  position: relative;
`;

export const CustomRadio = styled.span`
  position: relative;
  width: 18px;
  height: 18px;
  border: ${props => (props.checked ? 'none' : '1px solid #dcdcdc')};
  background-color: ${props =>
    props.disabled ? GRAY_LIGHTER : props.checked ? MAIN_COLOR : 'transparent'};
  border-radius: 100px;
  cursor: pointer;
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const LabelContainer = styled.label`
  ${flexPosition({ align: 'flex-start', justify: 'flex-start' })}
`;

export const Label = styled.span`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
`;

export const Desc = styled.span`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
`;

export const DescContainer = styled.span`
  ${flexPosition({})}
  flex-direction: column;
  ${props => props.customDescStyles}
`;



// WEBPACK FOOTER //
// ./src/components/Radio/style.js